import { EnRouteInventoryFiltersInputSchema } from "@redotech/redo-inventory-common/en-route-inventory/en-route-inventory-filters";
import { ReturnStatusZod } from "@redotech/redo-return-core-common/return-status-zod";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const EnRouteInventoryItemSchema_ = z.object({
  id: z.string(),
  returnId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
  quantity: z.number(),
  productStatus: z.string(),
  price: z.string().nullable(),
  returnStatus: ReturnStatusZod,
  teamName: z.string(),
  teamId: z.string(),
  trackingNumber: z.string().nullable(),
  carrier: z.string().nullable(),
  createdAt: z.date(),
  isFinalSaleReturn: z.boolean(),
  returnsCenterId: z.string().nullable(),
});

export const EnRouteInventoryItemSchema: z.ZodType<EnRouteInventoryItem> =
  EnRouteInventoryItemSchema_;
export interface EnRouteInventoryItem extends z.infer<
  typeof EnRouteInventoryItemSchema_
> {}

export const getEnRouteInventory = unaryRpc({
  name: "getEnRouteInventory" as const,
  input: EnRouteInventoryFiltersInputSchema.extend({
    page: z.number().min(0).default(0).optional(),
    pageSize: z.number().min(1).max(500).default(20).optional(),
  }),
  output: z.object({
    items: z.array(EnRouteInventoryItemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});

const EnRouteTeamSchema_ = z.object({ id: z.string(), name: z.string() });

export const EnRouteTeamSchema: z.ZodType<EnRouteTeam> = EnRouteTeamSchema_;
export interface EnRouteTeam extends z.infer<typeof EnRouteTeamSchema_> {}

export const getEnRouteTeams = unaryRpc({
  name: "getEnRouteTeams" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({ teams: z.array(EnRouteTeamSchema) }),
});
